const DROPDOWN_GAP = 6;
const VIEWPORT_PADDING = 8;

export type DropdownPlacement = "top" | "bottom";

interface AnchorPosition {
  top: number;
  bottom: number;
}

interface DropdownSize {
  height: number;
}

interface ViewportSize {
  height: number;
}

export interface DropdownPosition {
  placement: DropdownPlacement;
  maxHeight: number;
}

/**
 * 下方空间足够时保持默认向下展开；不足时优先选择空间更充裕的一侧，
 * 并返回该侧允许的最大高度，避免选项过多时超出视口。
 */
export function calculateDropdownPosition(
  anchor: AnchorPosition,
  dropdown: DropdownSize,
  viewport: ViewportSize,
): DropdownPosition {
  const spaceAbove = Math.max(0, anchor.top - VIEWPORT_PADDING - DROPDOWN_GAP);
  const spaceBelow = Math.max(0, viewport.height - VIEWPORT_PADDING - anchor.bottom - DROPDOWN_GAP);
  const placement: DropdownPlacement =
    spaceBelow >= dropdown.height || spaceBelow >= spaceAbove ? "bottom" : "top";

  return {
    placement,
    maxHeight: placement === "top" ? spaceAbove : spaceBelow,
  };
}
